module.exports = __webpack_public_path__ + "img/hex.c6020e43.png";